<template>
  <span>
    <v-card>
      <v-card-title class="primary white--text">
        <span class="headline mr-2">{{ $t('editObligationRate') }}</span>
        <v-spacer/>
        <Icon
        @icon-clicked="$emit('close')"
        :tooltipText="$t('close')"
        iconColor="white"
        icon="mdi-close"
        :small="false"
        large
        />
      </v-card-title>
      <v-card-text>
        <FormWrapper
        @submit="trySaveRate"
        :buttonText="$t('saveChanges')">
          <v-row class="mt-1">
            <v-col cols="12">
              <v-text-field
              ref="name"
              v-model="namedRate.name"
              :label="$t('name')"
              required
              counter="32"
              maxLength="32"
              outlined
              />
            </v-col>
          </v-row>
          <v-row class="px-2 mt-n4 mb-3">
            <v-col cols="12">
              <BaseCostForm
              :propBaseCost="propNamedRate?.costCalculation"
              :accountingCategory="AccountingCategory.Payable.value"
              :accountId="accountId"
              editing
              :allowRateSheet="allowRateSheet"
              @base-cost-changed="baseCostChanged"
              :payByTypes="[PayBy.Volume]"
              hideRate
              :hidePayBy="true"
              rateSheetHint
              :isLogsContract="false"/>
            </v-col>
          </v-row>
          <template #left-action v-if="editing">
            <v-row class="px-2 mb-1">
              <v-col cols="12">
                <Icon
                icon="mdi-information-outline"
                :small="false"
                iconColor="info"/>
                <em>
                  {{ $t('obligationRateContractWarning') }}
                </em>
              </v-col>
            </v-row>
          </template>
        </FormWrapper>
      </v-card-text>
    </v-card>
    <v-dialog
      v-if="confirmSubmitDialog"
      v-model="confirmSubmitDialog"
      width="400px"
    >
      <ConfirmDialog
        :title="$t('confirmSaveChanges')"
        :body="$t('confirmTractUpdateMessage')"
        color="primary"
        :confirmText="$t('confirm')"
        @confirm="saveRate"
        @cancel="confirmSubmitDialog = false"
      />
    </v-dialog>
  </span>
</template>

<script>
import { AccountingCategory, NamedRateSpecialization, PayBy } from '@/utils/Enumerations'
import { mapGetters, mapActions } from 'vuex'
import { cloneDeep } from 'lodash'
export default {
  name: 'NamedRateForm',

  components: {
    Icon: () => import('@/components/helper/Icon.vue'),
    FormWrapper: () => import('@/components/core/FormWrapper.vue'),
    BaseCostForm: () => import('@/components/activity/BaseCostForm.vue'),
    ConfirmDialog: () => import('@/components/helper/ConfirmDialog.vue')
  },

  props: {
    propNamedRate: { type: Object, default: undefined },
    tractGroup: { type: Object, required: true },
    deferSave: { type: Boolean, default: false }
  },

  data: () => ({
    PayBy,
    AccountingCategory,
    confirmSubmitDialog: false,
    namedRate: {
      name: '',
      costCalculation: undefined
    }
  }),

  computed: {
    ...mapGetters('user', ['businessEntities', 'companyInfo']),
    accountId () {
      return this.businessEntities.find(be => be.businessEntityId === this.tractGroup.businessEntityId)?.accountId
    },

    allowRateSheet () {
      return this.accountId != null
    },

    editing () {
      return this.propNamedRate != null
    },

    requiresApproval () {
      return this.companyInfo.requireApprovalForContractModifications
    }
  },

  created () {
    if (this.propNamedRate) {
      this.namedRate = (this.namedRate, cloneDeep(this.propNamedRate))
      return
    }
    requestAnimationFrame(_ => { this.$refs.name.focus() })
  },

  methods: {
    ...mapActions('tract', ['createNamedRate', 'updateNamedRate']),

    trySaveRate () {
      if (this.namedRate.costCalculation.rateSheet == null) {
        this.setSnackError(this.$t('rateSheetIsRequired'))
        return
      }
      if (this.namedRate.name == null || this.namedRate.name.trim() === '') {
        this.setSnackError(this.$t('nameIsRequired'))
        return
      }
      if (this.requiresApproval) {
        this.confirmSubmitDialog = true
      } else {
        this.saveRate()
      }
    },

    async saveRate () {
      this.confirmSubmitDialog = false
      if (this.deferSave) {
        this.$emit('named-rate-changed', {
          ...this.namedRate,
          specialization: NamedRateSpecialization.Obligation.value
        })
        this.$emit('close')
        return
      }
      if (this.editing) {
        if (this.namedRate.costCalculation?.rateSheet != null) {
          this.namedRate.costCalculation.rateSheet.rateSheetLines ??= []
        }
        await this.updateNamedRate({
          ...this.namedRate,
          tractGroupId: this.tractGroup.tractGroupId
        })
      } else {
        await this.createNamedRate({
          ...this.namedRate,
          tractGroupId: this.tractGroup.tractGroupId,
          specialization: NamedRateSpecialization.Obligation.value
        })
      }
      this.$emit('close', true)
    },

    baseCostChanged (newBaseRate) {
      this.namedRate.costCalculation = newBaseRate
    }
  }
}
</script>
